// Internationalization (i18n) configuration
import { createContext, useContext } from 'react'

// Language data
export const languages = {
  en: {
    name: 'English',
    code: 'en',
    flag: '🇺🇸'
  },
  zh: {
    name: '中文',
    code: 'zh',
    flag: '🇨🇳'
  },
  es: {
    name: 'Español',
    code: 'es',
    flag: '🇪🇸'
  },
  fr: {
    name: 'Français',
    code: 'fr',
    flag: '🇫🇷'
  },
  de: {
    name: 'Deutsch',
    code: 'de',
    flag: '🇩🇪'
  },
  ja: {
    name: '日本語',
    code: 'ja',
    flag: '🇯🇵'
  },
  ko: {
    name: '한국어',
    code: 'ko',
    flag: '🇰🇷'
  }
}

// Translation data
export const translations = {
  en: {
    // Navigation
    nav: {
      convert: 'Convert',
      compress: 'Compress',
      tools: 'Tools',
      api: 'API',
      pricing: 'Pricing',
      signIn: 'Sign In',
      signUp: 'Sign Up',
      dashboard: 'Dashboard',
      billing: 'Billing',
      signOut: 'Sign Out'
    },
    
    // Home page
    home: {
      title: 'File Converter',
      subtitle: 'Easily convert files from one format to another, online.',
      chooseFiles: 'Choose Files',
      fromDevice: 'From Device',
      fromDropbox: 'From Dropbox',
      fromGoogleDrive: 'From Google Drive',
      fromOneDrive: 'From OneDrive',
      fromUrl: 'From URL',
      maxFileSize: 'Max file size 1GB. Upgrade for more',
      selectedFiles: 'Selected Files:',
      startConversion: 'Start Conversion',
      whyChooseUs: 'Why Choose Us',
      whyChooseUsSubtitle: 'We provide the most comprehensive, secure, and fast online file conversion service',
      fastConversion: 'Fast Conversion',
      fastConversionDesc: 'Support 1500+ file formats with fast processing and high quality',
      crossPlatform: 'Cross-Platform',
      crossPlatformDesc: 'Works on Windows, Mac, Linux and mobile devices, all major browsers',
      privacyProtected: 'Privacy Protected',
      privacyProtectedDesc: '256-bit SSL encryption, automatic file deletion, ensuring data security',
      supportedFormats: 'Supported File Formats',
      supportedFormatsSubtitle: 'Support for over 1500 file format conversions',
      video: 'Video',
      audio: 'Audio',
      image: 'Image',
      document: 'Document',
      wantToConvert: 'Want to convert large files without queue or ads?',
      upgradeNow: 'Upgrade now to enjoy unlimited conversions and faster speeds',
      upgradeButton: 'Upgrade Now',
      signUpFree: 'Sign Up for Free'
    },

    // Popup
    popup: {
      offerExpires: 'Offer expires in:',
      minutes: 'Minutes',
      seconds: 'Seconds',
      waitBeforeGo: 'Wait, before you go...',
      getDiscount: 'Get',
      twentyPercent: '20% off',
      yourSubscription: 'your subscription or purchase.',
      processLargeFiles: 'Process large files with ease.',
      getOffer: 'GET OFFER'
    },
    
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      close: 'Close',
      open: 'Open',
      download: 'Download',
      upload: 'Upload'
    },
    
    // Footer
    footer: {
      description: 'Free online file converter supporting 1500+ formats',
      convert: 'Convert',
      videoConverter: 'Video Converter',
      audioConverter: 'Audio Converter',
      imageConverter: 'Image Converter',
      pdfConverter: 'PDF Converter',
      tools: 'Tools',
      fileCompressor: 'File Compressor',
      toolbox: 'Toolbox',
      support: 'Support',
      helpCenter: 'Help Center',
      contactUs: 'Contact Us',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      copyright: 'All rights reserved.'
    }
  },
  
  zh: {
    // Navigation
    nav: {
      convert: '转换',
      compress: '压缩',
      tools: '工具',
      api: 'API',
      pricing: '定价',
      signIn: '登录',
      signUp: '注册',
      dashboard: '控制台',
      billing: '账单',
      signOut: '退出登录'
    },
    
    // Home page
    home: {
      title: '文件转换器',
      subtitle: '轻松将文件从一种格式转换为另一种格式，在线操作。',
      chooseFiles: '选择文件',
      fromDevice: '从设备',
      fromDropbox: '从 Dropbox',
      fromGoogleDrive: '从 Google Drive',
      fromOneDrive: '从 OneDrive',
      fromUrl: '从 URL',
      maxFileSize: '最大文件大小 1GB。升级以获得更多功能',
      selectedFiles: '已选择的文件:',
      startConversion: '开始转换',
      whyChooseUs: '为什么选择我们',
      whyChooseUsSubtitle: '我们提供最全面、最安全、最快速的在线文件转换服务',
      fastConversion: '快速转换',
      fastConversionDesc: '支持1500+文件格式转换，处理速度快，质量高',
      crossPlatform: '跨平台支持',
      crossPlatformDesc: '支持Windows、Mac、Linux和移动设备，所有主流浏览器',
      privacyProtected: '隐私保护',
      privacyProtectedDesc: '256位SSL加密传输，文件自动删除，确保数据安全',
      supportedFormats: '支持的文件格式',
      supportedFormatsSubtitle: '支持超过1500种文件格式的转换',
      video: '视频',
      audio: '音频',
      image: '图像',
      document: '文档',
      wantToConvert: '想要转换大文件而不排队或看广告？',
      upgradeNow: '立即升级到高级版本，享受无限制转换和更快速度',
      upgradeButton: '立即升级',
      signUpFree: '注册免费账户'
    },

    // Popup
    popup: {
      offerExpires: '优惠即将过期：',
      minutes: '分钟',
      seconds: '秒',
      waitBeforeGo: '等等，在你离开之前...',
      getDiscount: '获得',
      twentyPercent: '8折优惠',
      yourSubscription: '你的订阅或购买。',
      processLargeFiles: '轻松处理大文件。',
      getOffer: '获取优惠'
    },
    
    // Common
    common: {
      loading: '加载中...',
      error: '错误',
      success: '成功',
      cancel: '取消',
      save: '保存',
      delete: '删除',
      edit: '编辑',
      back: '返回',
      next: '下一步',
      previous: '上一步',
      close: '关闭',
      open: '打开',
      download: '下载',
      upload: '上传'
    },
    
    // Footer
    footer: {
      description: '支持1500+格式的免费在线文件转换器',
      convert: '转换',
      videoConverter: '视频转换',
      audioConverter: '音频转换',
      imageConverter: '图像转换',
      pdfConverter: 'PDF转换',
      tools: '工具',
      fileCompressor: '文件压缩',
      toolbox: '工具箱',
      support: '支持',
      helpCenter: '帮助中心',
      contactUs: '联系我们',
      privacyPolicy: '隐私政策',
      termsOfService: '服务条款',
      copyright: '版权所有。'
    }
  },
  
  es: {
    // Navigation
    nav: {
      convert: 'Convertir',
      compress: 'Comprimir',
      tools: 'Herramientas',
      api: 'API',
      pricing: 'Precios',
      signIn: 'Iniciar Sesión',
      signUp: 'Registrarse',
      dashboard: 'Panel',
      billing: 'Facturación',
      signOut: 'Cerrar Sesión'
    },
    
    // Home page
    home: {
      title: 'Convertidor de Archivos',
      subtitle: 'Convierte fácilmente archivos de un formato a otro, en línea.',
      chooseFiles: 'Elegir Archivos',
      fromDevice: 'Desde Dispositivo',
      fromDropbox: 'Desde Dropbox',
      fromGoogleDrive: 'Desde Google Drive',
      fromOneDrive: 'Desde OneDrive',
      fromUrl: 'Desde URL',
      maxFileSize: 'Tamaño máximo de archivo 1GB. Actualizar para más',
      selectedFiles: 'Archivos Seleccionados:',
      startConversion: 'Iniciar Conversión',
      whyChooseUs: 'Por Qué Elegirnos',
      whyChooseUsSubtitle: 'Proporcionamos el servicio de conversión de archivos en línea más completo, seguro y rápido',
      fastConversion: 'Conversión Rápida',
      fastConversionDesc: 'Soporte para 1500+ formatos de archivo con procesamiento rápido y alta calidad',
      crossPlatform: 'Multiplataforma',
      crossPlatformDesc: 'Funciona en Windows, Mac, Linux y dispositivos móviles, todos los navegadores principales',
      privacyProtected: 'Privacidad Protegida',
      privacyProtectedDesc: 'Cifrado SSL de 256 bits, eliminación automática de archivos, garantizando la seguridad de los datos',
      supportedFormats: 'Formatos de Archivo Soportados',
      supportedFormatsSubtitle: 'Soporte para más de 1500 conversiones de formatos de archivo',
      video: 'Video',
      audio: 'Audio',
      image: 'Imagen',
      document: 'Documento',
      wantToConvert: '¿Quieres convertir archivos grandes sin cola o anuncios?',
      upgradeNow: 'Actualiza ahora para disfrutar de conversiones ilimitadas y velocidades más rápidas',
      upgradeButton: 'Actualizar Ahora',
      signUpFree: 'Registrarse Gratis'
    },

    // Popup
    popup: {
      offerExpires: 'La oferta expira en:',
      minutes: 'Minutos',
      seconds: 'Segundos',
      waitBeforeGo: 'Espera, antes de que te vayas...',
      getDiscount: 'Obtén',
      twentyPercent: '20% de descuento',
      yourSubscription: 'en tu suscripción o compra.',
      processLargeFiles: 'Procesa archivos grandes con facilidad.',
      getOffer: 'OBTENER OFERTA'
    },
    
    // Common
    common: {
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      cancel: 'Cancelar',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      back: 'Atrás',
      next: 'Siguiente',
      previous: 'Anterior',
      close: 'Cerrar',
      open: 'Abrir',
      download: 'Descargar',
      upload: 'Subir'
    },
    
    // Footer
    footer: {
      description: 'Convertidor de archivos en línea gratuito que soporta 1500+ formatos',
      convert: 'Convertir',
      videoConverter: 'Convertidor de Video',
      audioConverter: 'Convertidor de Audio',
      imageConverter: 'Convertidor de Imagen',
      pdfConverter: 'Convertidor de PDF',
      tools: 'Herramientas',
      fileCompressor: 'Compresor de Archivos',
      toolbox: 'Caja de Herramientas',
      support: 'Soporte',
      helpCenter: 'Centro de Ayuda',
      contactUs: 'Contáctanos',
      privacyPolicy: 'Política de Privacidad',
      termsOfService: 'Términos de Servicio',
      copyright: 'Todos los derechos reservados.'
    }
  }
}

// Create context
export const I18nContext = createContext()

// Hook to use translations
export const useTranslation = () => {
  const context = useContext(I18nContext)
  if (!context) {
    throw new Error('useTranslation must be used within an I18nProvider')
  }
  return context
}

// True only in a real browser. During the build-time SSG render there is no
// window/localStorage/navigator, so we must fall back to the default language.
const isBrowser = typeof window !== 'undefined'

// Get browser language
export const getBrowserLanguage = () => {
  if (!isBrowser || typeof navigator === 'undefined') return 'en'
  const lang = navigator.language || navigator.userLanguage
  const code = lang.split('-')[0]
  return languages[code] ? code : 'en'
}

// Get stored language
export const getStoredLanguage = () => {
  if (!isBrowser) return 'en'
  return localStorage.getItem('fileflow-language') || getBrowserLanguage()
}

// Set stored language
export const setStoredLanguage = (code) => {
  if (!isBrowser) return
  localStorage.setItem('fileflow-language', code)
}

export default translations
